// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8ddfbe3f","239":"2ddf576e","453":"ed0bf531","732":"cffca867"}[chunkId] + ".chunk.js";
};